import avatarModule from '../avatarModule';

function avatarBack(avatarUrlConstants) {
  'ngInject';

  return {
    restrict: 'A',
    replace: false,
    templateUrl: avatarUrlConstants.templates.avatarBack
  };
}

avatarModule.directive('avatarBack', avatarBack);

export default avatarBack;
